import axiosHelper from "../../../../axiosHelper";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_ALL_ASSIGN_CFT,
  GET_NEW_REQUEST_HISTORY_EXPORT,
  GET_NSA_LIST,
  GET_PENDING_AUDIT_LIST,
  GET_VIEW_DETAIL_REPORT,
  IMPROVEMENT_PLAN_LIST,
} from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
import Toaster from "../../../common/Toaster";

// export function fetchNsaListing(filter, callback) {

//   return (dispatch) => {
//     const request = axiosHelper.get(`${APIUSEROLD.getNsaListing}`, {
//       params: {
//         EmployeeId: filter?.EmployeeId,
//         page: filter.current_page,
//         pageSize: filter.per_page,
//         applicationNo: filter?.ApplicationNo,
//         supplierCategory: filter?.CategoryName,
//         supplierName: filter?.SupplierName,
//         plantName: filter?.PlantName,
//         requestedBy: filter?.RequestedBy,
//         requestStatus: filter?.Status,
//         SortBy: filter?.sortField,
//         SortOrder: filter.sortOrder,
//         RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
//         RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
//       }, // Assuming filter contains necessary query parameters
//     });
//     request
//       .then((response) => {
//         if (response?.data || response.status === 204) {
//           dispatch({
//             type: GET_NSA_LIST,
//             payload: {
//               data: response.status === 204 ? [] : response?.data?.Result,

//               filter, // Include filter in payload
//             },
//           });
//           callback(response, null);
//         }
//       })
//       .catch((error) => {
//         dispatch({ type: API_FAILURE });
//         callback(null, error);
//         // apiErrors(error);
//       });
//   };
// }
export function fetchNsaListing(filter) {
  console.log('filter: ', filter);
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = axiosHelper.get(`${APIUSEROLD.getNsaListing}`, {
        params: {
          EmployeeId: filter?.EmployeeId,
          page: filter.current_page,
          pageSize: filter.per_page,
          auditorName: filter?.AuditorName,
          applicationNo: filter?.ApplicationNo,
          supplierCategory: filter?.CategoryName,
          auditorName: filter?.AuditorName,
          supplierName: filter?.SupplierName,
          plantName: filter?.PlantName,
          requestedBy: filter?.RequestedBy,
          requestStatus: filter?.Status,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
        },
      });

      request
        .then((response) => {
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_NSA_LIST,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Result,
                filter,
              },
            });
            resolve(response);
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{
            reject(error);
          }
         
        });
    });
  };
}


export function fetchNsaListingExport(filter, callback) {

  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getNsaListingExport}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          applicationNo: filter?.ApplicationNo,
          supplierCategory: filter?.CategoryName,
          auditorName: filter?.AuditorName,
          supplierName: filter?.SupplierName,
          plantName: filter?.PlantName,
          requestedBy: filter?.RequestedBy,
          requestStatus: filter?.Status,
          auditorName: filter?.AuditorName,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}
export function fetchAuditListingExport(filter, callback) {

  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getPendingAuditListExport}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          applicationNo: filter?.ApplicationNo,
          supplierCategory: filter?.CategoryName,
          supplierName: filter?.SupplierName,
          plantName: filter?.PlantName,

          requestedBy: filter?.RequestedBy,
          requestStatus: filter?.Status,
          SortBy: filter?.sortField,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}
export function fetchPendingAuditListing(filter) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = axiosHelper.get(`${APIUSEROLD.getPendingAuditListing}`, {
        params: {
          applicationNo: filter?.ApplicationNo,
          EmployeeId: filter?.EmployeeId,
          supplierCategory: filter?.CategoryName,
          supplierName: filter?.SupplierName,
          plantName: filter?.PlantName,
          requestedBy: filter?.RequestedBy,
          requestStatus: filter?.Status,
          page: filter.current_page,
          pageSize: filter.per_page,
          SearchText: filter?.sortField?.supplierName,
          SortBy: filter?.sortField || filter?.sortField?.supplierName,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
        },
      });

      request
        .then((response) => {
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_PENDING_AUDIT_LIST,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Result,
                filter,
              },
            });
            resolve(response);
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{
            reject(error);
          }
        });
    });
  };
}


export function getAssiginCftListingServices(idData) {
  const request = axiosHelper.get(`${APIUSEROLD.getCftListing}?VendorRequirementRegistrationId=${idData}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error; // Re-throw the error to the caller
      }
   
    });
}
export function getRegionListingServices() {
  const request = axiosHelper.get(`${APIUSEROLD.getRegionListingService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error; // Re-throw the error to the caller
      }
    });
}

export function addAssignCft(data, callback) {
  return (dispatch) => {
    const request = axiosHelper.post(APIUSEROLD.addAssignCft, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        Toaster.error(error?.response?.data?.ErrorMessage);
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          throw error; // Re-throw the error to the caller
        }
      });
  };
}
export function getDownloadReport(data) {
  const request = axiosHelper.post(`${APIUSEROLD.getDownloadReport}?VendorRequirementRegistrationId=${data?.VendorRequirementRegistrationId}&NSAAuditDetailId=${data?.NSAAuditDetailId}`,);
  return request
    .then((response) => {


      // if (response.data.Result) {
      //   // You can perform additional actions if needed
      // }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      // apiErrors(error);
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error; // Re-throw the error to the caller
      }
    });
}
export function addAssignCftSave(data, callback) {
  return (dispatch) => {
    const request = axiosHelper.post(APIUSEROLD.addAssignCftSave, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        Toaster.error(error?.response?.data?.ErrorMessage);
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          throw error; // Re-throw the error to the caller
        }
      });
  };
}
export function fetchAllAssignCftList(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getAllAssignCftList}`, {
      params: {
        NSAAuditDetailId: filter.empId,
        VNFID: filter.cftId,
      }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_ALL_ASSIGN_CFT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}
export function deleteAssifnCft(id, callback) {
  axiosHelper
    .delete(`${APIUSEROLD.deleteAssignCft}?Id=${id}`)
    .then((response) => {
      if (callback) {
        callback(null, response); // Call the callback with null for the error parameter and the response
      }
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        if (callback) {
          callback(error, null); // Call the callback with the error and null for the response
        }
      }
      
    });
}

export async function excelDownloadNsaList(params) {
  try {
    const response = await axiosHelper.post(`${APIUSEROLD.exportNsaList}`, {
      EmployeeId: params.EmployeeId,
      PlantCode: params?.PlantCode,
      CategoryCode: params?.CategoryCode,
      Status: params?.Status,
      RequestFromDate: params?.fromDate || null,
      RequestToDate: params?.toDate || null,
      searchText: params?.searchText,
    });
    const fileUrl = response.data.Data[0];
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    if (error.response.status === 401) {
      apiErrors(error)
    }else{
      throw error;
    }
    
  }
}
export async function excelDownloadPedingAuditList(params) {
  try {
    const response = await axiosHelper.post(
      `${APIUSEROLD.exportPendingAuditList}`,
      {
        EmployeeId: params.EmployeeId,
        PlantCode: params?.PlantCode,
        CategoryCode: params?.CategoryCode,
        Status: params?.Status,
        RequestFromDate: params?.fromDate || null,
        RequestToDate: params?.toDate || null,
        searchText: params?.searchText,
      }
    );
    const fileUrl = response.data.Data[0];
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {

    if (error.response.status === 401) {
      apiErrors(error)
    }else{
      throw error;
    }
  }
}

export function fetchViewDetailReport(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getViewDetailReport}`, {
      params: {
        VendorRequirementRegistrationId: filter?.vendorID,
        NSAAuditDetailId: filter.nsaAuditDetailId,
      }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_VIEW_DETAIL_REPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}

export function UpdateViewDetailReportService(data, resolve, reject) {
  return (dispatch) => {
    const request = axiosHelper.post(APIUSEROLD.updateViewDetailReport, data);
    request
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          reject(new Error("Unexpected response format."));
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{

          reject(error);
        }
      });
  };
}


export function fetchAllImprovementListing(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.fetchAllImprovementList}`, {
      params: {
        // NSAAuditDetailId: filter.empId,
        VendorRequirementRegistrationId: filter.vendorId,
        NSAAuditDetailId: filter.NSAAuditDetailId,
      }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: IMPROVEMENT_PLAN_LIST,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
      });
  };
}

export function intiateCorrectionAndApproveForImprovement(
  data,
  callback = () => { }
) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(
      APIUSEROLD.initiateRequestForCorrectionforImprovement,
      data
    );
    request
      .then((response) => {
        if (response.data) {
          callback(response);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          Toaster.error(error?.response?.data?.ErrorMessage);
          callback(error);
        }
       
      });
  };
}

export function nsaApproveReport(data, callback = () => { }) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.nsaApproveReport, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          Toaster.error(error?.response?.data?.ErrorMessage);
          callback(error);
        }
       
      });
  };
}
export function nsaApproveKYSReport(data, callback = () => { }) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.nsaApproveKYSReport, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          Toaster.error(error?.response?.data?.ErrorMessage);
          callback(error);
        }
        
      });
  };
}
export function intiateExceptionFlow(data, callback = () => { }) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.intiateExceptionFlow, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          Toaster.error(error?.response?.data?.ErrorMessage);
          callback(error);
        }
        
      });
  };
}
export function reAuditFlow(data, callback = () => { }) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.reAuditFlow, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          Toaster.error(error?.response?.data?.ErrorMessage);
          callback(error);
        }
        
      });
  };
}
export function nsaRequestReviewReport(data, callback = () => { }) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.nsaRequestReviewReport, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }else{
          Toaster.error(error?.response?.data?.ErrorMessage);
          callback(error);
        }
       
      });
  };
}

export function getReasonAuditListing() {
  const request = axiosHelper.get(`${APIUSEROLD.getReasonAuditListing}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getExceptionFlowSummaryListingService(vendorRegId, nsaAuditDetailId) {
  const request = axiosHelper.get(`${APIUSEROLD.getExceptionFlowSummaryListing}`, {
    params: {
      VendorRequirementRegistrationId: vendorRegId,
      NSAAuditDetailId: nsaAuditDetailId,
    }
  });

  return request
    .then((response) => {

      // if (response.data.Result) {
      //   // You can perform additional actions if needed
      // }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error; // Re-throw the error to the caller
      }
     
    });
}

export function getVersioningListingDataService(
  vendorRequirementRegistrationId,
  nsaauditDetailId
) {
  const request = axiosHelper.get(
    `${APIUSEROLD.getVersionListData}?VendorRequirementRegistrationId=${vendorRequirementRegistrationId}&NSAAuditDetailId=${nsaauditDetailId}`
  );
  return request
    .then((response) => {

      if (response?.data) {
        // You can perform additional actions if needed
        return response?.data; // Return the response to the caller
      }
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error; // Re-throw the error to the caller
      }
    });
}
